import { Box, Typography, Grid } from '@mui/material';
import { MultiCurrencyConfig } from 'config/multi-currency-config';
import React, { FC, Fragment, ReactNode } from 'react';
import { FormatCurrency, FormatCurrencyType, MutedText } from 'shared/components/Format/Currency';
import { useBalancesConfig } from '../../hooks/use-balances-config';
import { AvailableSingleCurrencyBalance } from './AvailableSingleCurrencyBalance';
import { useStyles } from './AvailableBalance.styles';
import { ExchangeRate } from '../ExchangeRate';
import { MISSING_ACCOUNT_PLACEHOLDER } from 'modules/payments/constants';

interface AvailableBalanceProps {
  onlyActive: boolean;
  subTitle?: string | ReactNode;
}

export const AvailableBalance: FC<AvailableBalanceProps> = ({ subTitle, onlyActive = true }) => {
  const { balancesConfig } = useBalancesConfig(onlyActive);
  const isSingleBalance = balancesConfig.length === 1;
  const { classes } = useStyles({ isSingleBalance });

  if (!MultiCurrencyConfig.isReplenishmentEnabled()) {
    return <AvailableSingleCurrencyBalance subTitle={subTitle} />;
  }

  return (
    <>
      <Typography mb={2} variant="h6">
        Available balance:
      </Typography>
      <Box className={classes.root}>
        <Grid container columnSpacing={{ xs: 1, md: 2 }} alignItems="baseline">
          {balancesConfig.map(({ account, fiatEquivalent, isRateVisible }) => (
            <Fragment key={account.currency}>
              <Grid item xs={isSingleBalance ? 12 : 6} className={classes.balanceContainer}>
                <Typography variant="h4" className={classes.amount}>
                  {account ? (
                    <FormatCurrency
                      amount={account.balance}
                      currency={account.currency}
                      type={FormatCurrencyType.Crypto}
                    />
                  ) : (
                    MISSING_ACCOUNT_PLACEHOLDER
                  )}
                </Typography>
                <Typography variant="h5" ml={1} className={classes.amount}>
                  <MutedText>≈&nbsp;</MutedText>
                  <FormatCurrency
                    amount={fiatEquivalent}
                    type={FormatCurrencyType.FiatCode}
                    currency="USD"
                  />
                </Typography>
              </Grid>
              {isRateVisible && (
                <>
                  <Grid item xs={0} sm={6} />
                  <Grid item xs={12} sm={6}>
                    <ExchangeRate placement="bottom" />
                  </Grid>
                </>
              )}
            </Fragment>
          ))}
        </Grid>
      </Box>
    </>
  );
};
